import { supabase } from "@/lib/supabase";

function deleteAccountFunctionUrl(): string {
  const base = import.meta.env.VITE_SUPABASE_URL;
  if (!base) throw new Error("Missing VITE_SUPABASE_URL");
  return `${base}/functions/v1/delete-account`;
}

function deleteAccountAnonKey(): string {
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!key) throw new Error("Missing VITE_SUPABASE_ANON_KEY");
  return key;
}

export type DeleteAccountResult = {
  success: boolean;
  message?: string;
  error?: string;
};

export async function deleteAccount(): Promise<DeleteAccountResult> {
  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session?.access_token) {
    throw new Error("Not authenticated");
  }

  const res = await fetch(deleteAccountFunctionUrl(), {
    method: "POST",
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      apikey: deleteAccountAnonKey(),
      "Content-Type": "application/json",
    },
  });

  const body = (await res.json().catch(() => ({}))) as DeleteAccountResult;

  if (!res.ok || !body.success) {
    throw new Error(body.error ?? "Account deletion failed");
  }

  return body;
}
